/** The search endpoint answered with a status instead of a stream. The search stream refuses with a 4xx (AG-13); a 5xx is its failing. */
export class SearchRequestFailed extends Error {
    constructor(readonly status: number) {
        super(`Search stream failed: ${status}`)
    }
}

/** A 4xx: the endpoint turned the search away (quota, access) rather than failing at it. */
export const isSearchRefusal = (error: unknown): boolean => error instanceof SearchRequestFailed && error.status >= 400 && error.status < 500
